export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10851.e6f82745.jpg";